import { LANGUAGE_OPTIONS } from './constants';
import { encrypted } from '../../../utils/utility';

export const getLanguage = () => {
  const encryptedLang = localStorage.getItem('lang');
  let localStorageLang: string | null = null;

  if (encryptedLang) {
    try {
      localStorageLang = encrypted.decrypt(encryptedLang);
    } catch (err) {
      console.error('Failed to decrypt language from localStorage:', err);
    }
  }

  const lang = LANGUAGE_OPTIONS.find(
    (option) => option.value == localStorageLang
  )?.value;
  if (lang) {
    return lang;
  } else {
    const browserLang = navigator.language;
    const lang = LANGUAGE_OPTIONS.find((option) => {
      const optionValue = option.value;
      return (
        optionValue == browserLang ||
        browserLang.includes(optionValue) ||
        optionValue.includes(browserLang)
      );
    })?.value;

    return lang || 'en';
  }
};

export const getLanguageLabel = (langCode: string) => {
  return LANGUAGE_OPTIONS.find(
    (lang) => lang.value === langCode
  )?.label;
};
